export default __webpack_public_path__ + "static/media/sim-pro-logo.6fae7d55.svg";